import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/components/accordion/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/components/button/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddDevicesComponent } from './add-devices.component';
import { InputTextModule } from 'primeng/components/inputtext/inputtext';
import { EditDeviceComponent } from './edit-device/edit-device.component';

@NgModule({
  declarations: [AddDevicesComponent, EditDeviceComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    FormsModule,
    CheckboxModule,
    InputTextModule,
    ReactiveFormsModule,
    AccordionModule,
  ],
  exports: [AddDevicesComponent],
})
export class AddDevicesModule {}
